import { render, staticRenderFns } from "./UAPromoArea.vue?vue&type=template&id=c2864b9e&scoped=true&"
import script from "./UAPromoArea.vue?vue&type=script&lang=js&"
export * from "./UAPromoArea.vue?vue&type=script&lang=js&"
import style0 from "./UAPromoArea.vue?vue&type=style&index=0&id=c2864b9e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2864b9e",
  null
  
)

export default component.exports